import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Add a listener for one of the supported events (`}<inlineCode parentName="p">{`change`}</inlineCode>{`, `}<inlineCode parentName="p">{`focus`}</inlineCode>{` and `}<inlineCode parentName="p">{`blur`}</inlineCode>{`) and return a function that can be called without arguments to remove the listener.`}</p>
    <p><inlineCode parentName="p">{`focus`}</inlineCode>{` and `}<inlineCode parentName="p">{`blur`}</inlineCode>{` listeners do not receive any arguments.`}</p>
    <p><inlineCode parentName="p">{`change`}</inlineCode>{` listeners receive the following arguments:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`valueToken`}</inlineCode>{`: a string representing the actual CVV value not accessible for security reasons  `}</li>
      <li parentName="ul"><inlineCode parentName="li">{`metadata`}</inlineCode>{`: additional details on the state of the input field wrapped by the CvvInput.`}</li>
    </ul>
    <p>{`Both `}<inlineCode parentName="p">{`valueToken`}</inlineCode>{` and `}<inlineCode parentName="p">{`metadata`}</inlineCode>{` can be also accessed directly on an instance of `}<inlineCode parentName="p">{`CvvInput`}</inlineCode>{` (`}<inlineCode parentName="p">{`cvvInput.valueToken`}</inlineCode>{`, `}<inlineCode parentName="p">{`cvvInput.metadata`}</inlineCode>{`)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      